import {
  SHOW_NOTIFICATION,
  HIDE_NOTIFICATION,
} from "../actions/notification";

const initialState = {
  visible: false,
  message: "",
  color: "info",
  title: null,
  duration: 4500,
  actionLabel: null,
  actionTo: null,
};

const notificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_NOTIFICATION:
      return {
        visible: true,
        message: action.payload.message,
        color: action.payload.color || "info",
        title: action.payload.title || null,
        duration: action.payload.duration || 4500,
        actionLabel: action.payload.actionLabel || null,
        actionTo: action.payload.actionTo || null,
      };
    case HIDE_NOTIFICATION:
      return {
        ...state,
        visible: false,
        actionLabel: null,
        actionTo: null,
      };
    default:
      return state;
  }
};

export default notificationReducer;
